import React from 'react';
import { motion } from 'framer-motion';

const CSSStarfieldBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 w-full h-full -z-10 overflow-hidden" style={{ background: 'hsl(222.2 84% 4.9%)' }}>
      
      {/* CSS-based starfield layers with fewer, more random stars */}
      <motion.div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(1px 1px at 73px 47px, rgba(255,255,255,0.8), transparent),
            radial-gradient(2px 2px at 234px 123px, rgba(255,255,255,0.6), transparent),
            radial-gradient(1px 1px at 456px 89px, #fff, transparent),
            radial-gradient(1px 1px at 167px 234px, rgba(255,255,255,0.7), transparent),
            radial-gradient(1px 1px at 389px 156px, rgba(255,255,255,0.5), transparent),
            radial-gradient(2px 2px at 98px 345px, rgba(255,255,255,0.9), transparent),
            radial-gradient(1px 1px at 512px 67px, rgba(255,255,255,0.6), transparent),
            radial-gradient(1px 1px at 678px 234px, #eee, transparent)
          `,
          backgroundRepeat: 'repeat',
          backgroundSize: '800px 400px'
        }}
        animate={{
          backgroundPosition: ['0px 0px', '800px 400px']
        }}
        transition={{
          duration: 180,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      
      {/* Second layer with even fewer stars, different positions */}
      <motion.div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(1px 1px at 145px 78px, rgba(255,255,255,0.4), transparent),
            radial-gradient(1px 1px at 567px 189px, rgba(255,255,255,0.5), transparent),
            radial-gradient(1px 1px at 323px 298px, rgba(255,255,255,0.3), transparent),
            radial-gradient(1px 1px at 689px 134px, rgba(255,255,255,0.6), transparent),
            radial-gradient(1px 1px at 234px 367px, rgba(255,255,255,0.4), transparent)
          `,
          backgroundRepeat: 'repeat',
          backgroundSize: '700px 450px'
        }}
        animate={{
          backgroundPosition: ['0px 0px', '-700px -450px']
        }}
        transition={{
          duration: 140,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      
      {/* Third layer with very few bright stars */}
      <motion.div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(2px 2px at 412px 156px, rgba(255,255,255,0.9), transparent),
            radial-gradient(1px 1px at 678px 289px, rgba(255,255,255,0.7), transparent),
            radial-gradient(1px 1px at 123px 367px, rgba(255,255,255,0.8), transparent)
          `,
          backgroundRepeat: 'repeat',
          backgroundSize: '900px 500px'
        }}
        animate={{
          backgroundPosition: ['0px 0px', '450px 250px']
        }}
        transition={{
          duration: 220,
          repeat: Infinity,
          ease: "linear"
        }}
      />
    </div>
  );
};

export default CSSStarfieldBackground;
